<template>
  <v-dialog v-model="dialog" persistent width="100%">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>remove_red_eye</v-icon>Ver detalle solicitud
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12>
            <v-container grid-list-md style="min-width: 100%;" class="py-0">
              <v-flex xs12>
                <h4>
                  <strong>SERVIDOR PÚBLICO: </strong
                  >{{ this.form.servidor_publico }}
                </h4>
              </v-flex>
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    class="elevation-1 tabla-comprimida-light"
                    :headers="headers"
                    :items="lista_funcionarios_vacaciones"
                    no-data-text="Sin datos"
                  >
                    <!-- Cabecera -->
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            {{ props.header.text }}
                          </span>
                        </template>
                        <span>
                          {{ props.header.text }}
                        </span>
                      </v-tooltip>
                    </template>
                    <template v-slot:items="items">
                      <td class="text-xs-center">
                        {{ items.item.servidor_publico }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          $moment(
                            items.item.fecha_incorporacion,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_a }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_b }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_c }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.total_dias_saldo }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_programar }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_no_programados }}
                      </td>
                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[0]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[1]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[2]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[3]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[4]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[5]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[6]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[7]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[8]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[9]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[10]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th>INICIO</th>
                          <th>FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[11]"
                          :key="programacion.id"
                        >
                          <td>
                            {{ programacion.fecha_desde }}
                          </td>
                          <td>
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td class="text-xs-center">
                        {{ items.item.estado }}
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cerrrar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      form: {},
      lista_funcionarios_vacaciones: [],
      gestion: parseInt(this.$util.decodeString(this.$route.params.gestion)),
      unidad: this.$storage.get("user").unidad[0]
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Servidor público",
          value: "id",
          align: "center",
          class: "celda2"
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_solicitud",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 3}-${this.gestion -
            2}\n(A)`,
          value: "dias_saldo_a",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 2}-${this.gestion -
            1}\n(B)`,
          value: "dias_saldo_b",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 1}-${
            this.gestion
          }\n(C)`,
          value: "dias_saldo_c",
          align: "center"
        },
        {
          text: `TOTAL DIAS\n(A+B+C)`,
          value: "total_dias_saldo",
          align: "center"
        },
        {
          text: `TOTAL DIAS PROGRAMADOS DE ACUERDO A PORCENTAJE`,
          value: "dias_programar",
          align: "center"
        },
        {
          text: `TOTAL DIAS NO PROGRAMADOS`,
          value: "dias_no_programados",
          align: "center"
        },
        { text: "Ene", value: "ene", align: "center" },
        { text: "Feb", value: "feb", align: "center" },
        { text: "Mar", value: "mar", align: "center" },
        { text: "Abr", value: "abr", align: "center" },
        { text: "May", value: "may", align: "center" },
        { text: "Jun", value: "jun", align: "center" },
        { text: "Jul", value: "jul", align: "center" },
        { text: "Ago", value: "ago", align: "center" },
        { text: "Sep", value: "sep", align: "center" },
        { text: "Oct", value: "oct", align: "center" },
        { text: "Nov", value: "nov", align: "center" },
        { text: "Dic", value: "dic", align: "center" },
        { text: "Estado", value: "estado", align: "center", class: "celda2" }
      ];
    }
  },
  mounted() {
    this.$bus.$on("openDialogVerDetalleSolicitudesProgramacion", async item => {
      this.form = item;
      await this.cargarProgramaciones();
      (item.mes_enero = [
        {
          id: 1,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        },
        {
          id: 2,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        },
        {
          id: 3,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        }
      ]),
        this.lista_funcionarios_vacaciones.push(item);
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cargar el detalle de las programaciones
    async cargarProgramaciones() {
      let res;
      try {
        let usuario = this.$storage.get("user").id_persona;
        let vec_meses = [];
        let mayor_cantidad_registros = 1;
        for (let index = 0; index < 12; index++) {
          vec_meses.push([]);
        }
        res = await this.$service
          .graphql({
            query: `
            query{
            vVacaProgramadas(id_persona:${
              this.form.id_persona
            },restriccion_estados:"9,47",gestion:"${parseInt(this.gestion)}"){
              count
              rows{
                id
                fecha_desde
                fecha_hasta
                id_estado
                fecha_solicitud
                id_unidad
                total_dias
                estado
                id_persona
              }
            }
          }
          `
          })
          .then(response => {
            if (response) {
              let listado_programaciones = response.vVacaProgramadas.rows;

              listado_programaciones.forEach(element => {
                let mes_ini = parseInt(
                  this.$moment(element.fecha_desde, "DD/MM/YYYY").format("M")
                );
                let mes_fin = parseInt(
                  this.$moment(element.fecha_hasta, "DD/MM/YYYY").format("M")
                );
                if (mes_ini == mes_fin) {
                  vec_meses[mes_ini - 1].push(element);
                } else {
                  vec_meses[mes_ini - 1].push(element);
                  vec_meses[mes_fin - 1].push(element);
                }
              });

              vec_meses.forEach(element => {
                if (element.length > mayor_cantidad_registros) {
                  mayor_cantidad_registros = element.length;
                }
              });
              let contador = -1;
              for (let index2 = 0; index2 < vec_meses.length; index2++) {
                const element = vec_meses[index2];
                if (element.length < mayor_cantidad_registros) {
                  for (
                    let index = element.length;
                    index < mayor_cantidad_registros;
                    index++
                  ) {
                    element.push({
                      id: contador,
                      fecha_desde: "-",
                      fecha_hasta: "-"
                    });
                    contador = contador - 1;
                  }
                }
              }
              this.form.vector_meses = vec_meses;
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.valid = false;
      this.lista_funcionarios_vacaciones = [];
      this.$bus.$emit("closeDialogVerDetallesProg");
      this.dialog = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/VerDetalleSolicitudesProgramacion.vue